import React from 'react';
import style from './labeledItem.module.scss';
import classNames from 'classnames';

const LabeledItem: React.SFC<{
    label: JSX.Element | string,
    labelClassName?: string,
    linebreak?: boolean,
    includeColon?: boolean,
    className?: string,
}> =
        ({label, labelClassName, linebreak, includeColon = true, className, children}) => {
    if (!children) {
        return null;
    }
    return (
        <div className={className}>
            <span className={classNames(style.Label, {[style.Break]: linebreak}, labelClassName)}>
                {label}
                <span
                    className={style.Space}
                >
                    {includeColon ? ': ' : ' '}
                </span>
            </span>
                {children}
        </div>
    );
};

export { LabeledItem };
